module.exports = __webpack_public_path__ + "static/media/ClassicPic.82108fc5.png";